import { useTranslation } from "react-i18next";
import Button from "components/button/default";
import { useBookInfContext } from "components/context/bookInfContext";
import {
  fullDateFormat,
  getDurationDate,
  priceFormat,
  timeFormat,
} from "util/commAction";
import { useAuthContext } from "components/context/authContext";
import { useNavigate } from "react-router-dom";
import i18n from "locales/i18n";
import "./step4.scss";

export default function BookStep4() {
  const { t } = useTranslation();
  const langCd = i18n.language;
  const navigate = useNavigate();
  const { lodInf } = useAuthContext();
  const { bookInf, userInf } = useBookInfContext();

  const range = getDurationDate(bookInf?.dates[0], bookInf?.dates[1]);
  const userNm = userInf && userInf?.cstSurnm + userInf?.cstFstnm;

  return (
    <>
      <div className="rsv-complet">
        <div className="w-full">
          <div className="border-bt-1 pb-8">
            <h2 className="sub">
              {userNm + (langCd === "ko" ? "님" : "")}
              {t("ttl_bk_cmplt_bk")}
            </h2>
            <h5 className="text-blue-300 mt-3">{t("ttl_dscrp_bk")}</h5>
          </div>
          {/* 투숙정보 객실타입, 투숙인원, 추가 옵션, 투숙인원 */}
          <div>
            <ul className="flex flex-col border-bt-dashed py-6 gap-2 ">
              <li className="flex border-bt-dashed pb-6 mb-6 flex">
                <h5>{t("lbl_rsrv_nm_bk")}</h5>
                <h4 className="text-blue-300">{bookInf?.rmResvNo}</h4>
              </li>
              <li className="flex">
                <h5>{t("txt_rm_typ_bk")}</h5>
                <h4>{bookInf?.rmTypNm}</h4>
              </li>
              <li className="flex">
                <h5>{t("txt_nm_gst_bk")}</h5>
                <h4>
                  {" "}
                  {t("txt_adlt_bk")}&nbsp;{bookInf?.adltCnt}&nbsp;{"/"}&nbsp;
                  {t("txt_chld_bk")}&nbsp;
                  {bookInf?.childCnt}
                </h4>
              </li>
              <li className="flex">
                <h5>{t("txt_add_op_bk")}</h5>
                <h4>{t("txt_nan_bk")}</h4>
              </li>
            </ul>

            <ul className="flex flex-col gap-2 border-bt-dashed py-6 ">
              <li className="text-left">
                <h4 className="text-blue-300">
                  {t("rd_lbl_hm_ldg")}&nbsp;
                  {range}
                </h4>
              </li>
              <li className="flex">
                <h5>{t("txt_chck_in_cmm")}</h5>
                <h4>
                  {fullDateFormat(bookInf?.resvSDt)}&nbsp;/&nbsp;
                  {timeFormat(lodInf?.chkInTi ?? "") ?? "--"}{" "}
                </h4>
              </li>
              <li className="flex">
                <h5>{t("txt_chck_out_cmm")}</h5>
                <h4>
                  {fullDateFormat(bookInf?.resvEDt)}&nbsp;/&nbsp;
                  {timeFormat(lodInf?.chkOutTi ?? "") ?? "--"}{" "}
                </h4>
              </li>
            </ul>
            <div className="between-center py-6">
              <h4>{t("txt_total_prc_cmm")}</h4>
              <h2 className="sub text-blue-300">
                {priceFormat(bookInf?.sellTotAmt)}
              </h2>
            </div>
          </div>
        </div>
        <div className="center py-10">
          <Button
            text={t("btn_rsrv_chk_bk")}
            styels=""
            onClick={() => {
              localStorage.removeItem("bookInf");
              localStorage.removeItem("bkStep");
              // setBkStep(1);
              // localStorage.setItem("step", 1 + "");
              navigate("/mypage/resv");
            }}
          />
        </div>
      </div>
    </>
  );
}
